module.exports = __webpack_public_path__ + "img/my-bg.bbdc3259.png";